"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaPoliticalInstitute = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
var Card_1 = require("../Card");
var Turmoil_1 = require("../../turmoil/Turmoil");
var LunaPoliticalInstitute = (function (_super) {
    __extends(LunaPoliticalInstitute, _super);
    function LunaPoliticalInstitute() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNA_POLITICAL_INSTITUTE,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.EARTH],
            cost: 6,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.MOON, 2); }),
            metadata: {
                description: 'Requires that you have 2 Moon tags.',
                cardNumber: 'M71',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Move one of your delegates from the reserve to any party.', function (eb) { return eb.empty().startAction.delegates(1); });
                }),
            },
        }) || this;
    }
    ;
    LunaPoliticalInstitute.prototype.play = function () {
        return undefined;
    };
    LunaPoliticalInstitute.prototype.canAct = function (player) {
        return Turmoil_1.Turmoil.getTurmoil(player.game).hasAvailableDelegates(player.id);
    };
    LunaPoliticalInstitute.prototype.action = function (player) {
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send a delegate', { source: 'reserve' }));
        return undefined;
    };
    return LunaPoliticalInstitute;
}(Card_1.Card));
exports.LunaPoliticalInstitute = LunaPoliticalInstitute;
